import { render, staticRenderFns } from "./services-posts.vue?vue&type=template&id=139f08be&scoped=true&"
import script from "./services-posts.vue?vue&type=script&lang=js&"
export * from "./services-posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f08be",
  null
  
)

export default component.exports